import SectionReveal from "@/components/effects/SectionReveal";
import RevealText from "@/components/effects/RevealText";

const About = () => {
    return (
        <section id="about" className="relative py-24 md:py-40">
            <div className="container-x">
                <SectionReveal>
                    <p className="overline">01 — About</p>
                </SectionReveal>

                <div className="mt-6 grid gap-16 md:grid-cols-12 md:gap-12">
                    <div className="md:col-span-8">
                        <RevealText
                            as="h2"
                            className="text-3xl font-medium leading-[1.15] tracking-tight text-white sm:text-4xl md:text-6xl"
                            text="I build at the intersection of technology, business, design, and marketing — because that's where growth actually happens."
                        />
                    </div>
                    <SectionReveal delay={0.2} className="md:col-span-4">
                        <p className="text-base text-brand-muted md:text-lg">
                            My work isn’t about frameworks or trends. It’s about outcomes — measurable, defensible, and
                            paid for. Sites that convert. Stores that ship. Systems that compound.
                        </p>
                        <p className="mt-4 text-base text-brand-muted md:text-lg">
                            Between running Elite-Edge US, building BoostF, and consulting for founders across
                            geographies, I get to translate real business problems into engineered, opinionated
                            digital products.
                        </p>
                    </SectionReveal>
                </div>
            </div>
        </section>
    );
};

export default About;
